import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { fetchRecipe } from "@/lib/queries";

/**
 * Detaljesider er fjernet i v2. Gamle URLer 301-redirecter direkte til
 * opskriftens oprindelige kilde. Falder tilbage til /opskrifter hvis
 * kilden mangler eller opskriften ikke findes.
 */
export const Route = createFileRoute("/opskrift/$id")({
  loader: async ({ params }) => {
    const recipe = await fetchRecipe(params.id);
    if (!recipe) throw notFound();
    const target = recipe.original_url && /^https?:\/\//i.test(recipe.original_url)
      ? recipe.original_url
      : "https://flaneriet.online/opskrifter";
    throw redirect({ href: target, statusCode: 301 });
  },
  head: () => ({
    meta: [
      { title: "Flyttet – Flâneriet" },
      { name: "robots", content: "noindex,follow" },
    ],
  }),
  component: () => null,
});
